import { Breadcrumb, Input, message, Select, Timeline } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon } from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import style from "./SystemParameterEdit.module.css";
import axios from "axios";
import { ROUTES } from "../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useSelector } from "react-redux";
import moment from "moment";
import CustomDivider from "../../../component/divider/CustomDivider";

const SystemParameterDetail = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);

  const [userManagementOpen, setUserManagementOpen] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])

  useEffect(() => {
    fetchData();
  }, []);
  const api = GROLOG_URL
  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async () => {
    let id = 1;
    let res = await doGet(`/grolog-parameter/${location.state}?${param}`, token);
    console.log(res);
    setDetail(res?.data?.payload);
    getManagementHistoryList()
  };

  const doGetBaseUrl = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { "Authorization": token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(`audit/v1/grolog/audit?page=1&filter=table_name eq grolog_account_parameter, primary_key eq ${location.state}`)

    const data = res?.data?.payload
    const reorderedData = []

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element)
    }

    setManagementHistoryList(reorderedData)
  }

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }



  return (
    <>
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`System Parameter`}
          menuLevel4={`Detail ${detail.code}`}
        />

        <div className="flex items-center justify-between">
          <div onClick={() => navigate(ROUTES.PARAMETER.LIST)} className="cursor-pointer flex items-center gap-[22px]">
            <img
              src={BackIcon}
              alt=""

              className="cursor-pointer"
            />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail.code}
            </h1>
          </div>
          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detail?.updated_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.updated_at, true)}</strong></p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
        <CustomDivider name={t("PARAMETER:SYSTEM_PARAMETER_INFO")}/>
            <div className="flex">
              <div>
                {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
              {t("CUSTOMER:DRIVER_PROFILE")}
            </h3> */}
                <div className="flex">
                  <div className="gap-[40px] mb-[24px]">
                    {/* <div className="w-[500px] mb-[24px]"> */}
                      {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                        {t("PARAMETER:SYSTEM_PARAMETER_INFO")}
                      </h3> */}
                    {/* </div> */}

                    {/* //one */}
                    <div className="gap-[40px] mb-[24px]">
                      <div className="w-[350px] mb-[24px]">
                        <label className="font-roboto text-[14px] text-[#818181]">
                          {t("PARAMETER:PARAMETER_ID")}
                        </label>
                        <h4 className="font-roboto text-[20px] text-[#424242]">
                          {detail?.parameter_id}
                        </h4>
                      </div>
                      <div className="w-[350px] mb-[24px]">
                        <label className="font-roboto text-[14px] text-[#818181]">
                          {t("PARAMETER:PARAMETER_CODE")}
                        </label>
                        <h4 className="font-roboto text-[20px] text-[#424242]">
                          {detail?.code}
                        </h4>
                      </div>
                      <div className="w-[350px] mb-[24px]">
                        <label className="font-roboto text-[14px] text-[#818181]">
                          {t("PARAMETER:PARAMETER_VALUE")}
                        </label>
                        <h4 className="font-roboto text-[20px] text-[#424242]">
                          {detail?.char_value ? detail?.char_value : "-"}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            /> */}
          </div>

          <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
            <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
              <img src={CloseIcon} alt="" />
            </button>

            <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
            <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at)}</strong></p>


            <div className={style.timelineContainer}>
              <Timeline>
                {
                  managementHistoryList.map((item, index) => {
                    if (index === 0) {
                      return (
                        <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                      )
                    } else {
                      return (
                        <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                      )
                    }
                  })
                }
              </Timeline>
            </div>
          </aside>
        </div>


      </div>
    </>
  );
};
export default SystemParameterDetail;
